const COLUMNS = [
  {
    key: "invoice_tenant_number",
    label: "Fawter Number",
    filterLabel: "Fawter Number",
    sortable: true,
    searchable: true,
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "invoice_date",
    label: "Invoice Date",
    filterLabel: "Invoice Date",
    sortable: true,
    searchable: true,
    formatter: "formatCellDateTime",
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_subject",
    label: "Invoice",
    filterLabel: "Invoice Subject",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_merchant_number",
    label: "Invoice Number",
    filterLabel: "Invoice Number",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_po_reference",
    label: "PO Reference",
    filterLabel: "PO Reference",
    sortable: true,
    searchable: true,
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "invoice_status",
    label: "Status",
    filterLabel: "Status",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_merchant_legal_name",
    label: "Merchant Legal Name",
    filterLabel: "Merchant Legal Name",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_due_date",
    label: "Due Date",
    filterLabel: "Due Date",
    sortable: true,
    searchable: true,
    formatter: "formatCellDateTime",
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "invoice_currency_sign",
    label: "Currency",
    filterLabel: "Currency",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_subtotal",
    label: "Subtotal",
    filterLabel: "Subtotal",
    sortable: true,
    searchable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "invoice_tax_name",
    label: "Invoice Tax Name",
    filterLabel: "Invoice Tax Name",
    sortable: true,
    searchable: true,
    formatter: "upCase",
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_tax_rate",
    label: "Invoice Tax Rate",
    filterLabel: "Invoice Tax Rate",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_vat_total_amount",
    label: "Invoice Tax Amount",
    filterLabel: "Invoice Tax Amount",
    formatter: "formatCurrency",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "invoice_discount_amount",
    label: "Discount Amount",
    filterLabel: "Discount Amount",
    sortable: true,
    searchable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "invoice_total",
    label: "Invoice Total",
    filterLabel: "Invoice Total",
    sortable: true,
    searchable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "customer_fawter_fee_vat_rate",
    label: "Fawter Fees Tax Rate",
    filterLabel: "Fawter Fees Tax Rate",
    sortable: true,
    searchable: true,
    formatter: "formatPercentage",
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "customer_fawter_fee",
    label: "Fawter Fees",
    filterLabel: "Fawter Fees",
    sortable: true,
    searchable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "customer_payment_fee",
    label: "Payment Fees",
    filterLabel: "Payment Fees",
    sortable: true,
    searchable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "payment_total",
    label: "Payment Total",
    filterLabel: "Payment Total",
    sortable: true,
    searchable: true,
    formatter: "formatCurrency",
    visible: true,
    visibleSmallScreen: true,
    total: true,
    customClass: "align-data-end"
  },
  {
    key: "invoice_payment_date",
    label: "Payment Date",
    filterLabel: "Payment Date",
    sortable: true,
    searchable: true,
    formatter: "formatCellDateTime",
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_payment_method_name",
    label: "Payment Method",
    filterLabel: "Payment Method",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "invoice_offline_payment_option",
    label: "Offline Payment Method",
    filterLabel: "Offline Payment Method",
    sortable: true,
    searchable: true,
    visible: true,
    visibleSmallScreen: true
  },
  {
    key: "created_at",
    label: "Created At",
    filterLabel: "Created At",
    sortable: true,
    searchable: true,
    formatter: "formatCellDateTime",
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "updated_at",
    label: "Updated At",
    filterLabel: "Updated At",
    sortable: true,
    searchable: true,
    formatter: "formatCellDateTime",
    visible: false,
    visibleSmallScreen: false
  },
  {
    key: "link",
    label: "",
    filterLabel: "",
    visible: true,
    visibleSmallScreen: true,
    class: "data-table-body-row-link",
    thClass: "data-table-header-ghost"
  }
];

export function selectColumns () {
  return COLUMNS;
}
